import { map, switchMap, shareReplay, exhaustMap, mergeWith, scan } from 'rxjs/operators';
import { from, fromEventPattern, of, distinct, mapTo, catchError, timeout, take, defer } from 'rxjs';
import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import { apis } from '../../../config';
export class IM_Self {
    constructor() {
        this.sdk = null;
        this.observable = null;
        this.systemApi = masterApi.getSystemApi();
        this.eventApi = masterApi.getEventApi();
        this.contactApi = masterApi.requireLogicalApi(apis.contactApiImpl);
        this.accountApi = masterApi.requireLogicalApi(apis.accountApiImpl);
    }
    getSubject() {
        return this.observable;
    }
    init(sdk) {
        this.sdk = sdk;
        const onconnect = (handler) => {
            this.sdk.subscrible('onconnect', handler);
        };
        const offconnect = (handler) => {
            this.sdk.subscrible('onconnect', handler);
        };
        const fetchAccountInfo = async () => {
            try {
                const res = (await this.accountApi.fetchAccountInfo());
                return {
                    nick: lodashGet(res, 'data.data.nickName', ''),
                    account: lodashGet(res, 'data.data.yunxinAccountId', ''),
                };
            }
            catch (err) { }
            return {};
        };
        const $observable = fromEventPattern(onconnect, offconnect).pipe(exhaustMap(() => this.subscribeContactReady()), switchMap(() => {
            var _a, _b, _c, _d, _e, _f;
            console.log('[im.myaccount]contactReady');
            const user = this.systemApi.getCurrentUser();
            const account = ((_b = (_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contactInfo.find(item => item.contactItemType === 'yunxin')) === null || _b === void 0 ? void 0 : _b.contactItemVal) || '';
            const color = ((_d = (_c = user === null || user === void 0 ? void 0 : user.contact) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.color) || 'transparent';
            const pinyinname = ((_f = (_e = user === null || user === void 0 ? void 0 : user.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.contactPYName) || '';
            return of({
                nick: (user === null || user === void 0 ? void 0 : user.nickName) || '',
                email: (user === null || user === void 0 ? void 0 : user.id) || '',
                account,
                color: color,
                pinyinname,
            }).pipe(mergeWith(defer(() => {
                return from(fetchAccountInfo());
            })), scan((total, current) => {
                total = Object.assign(Object.assign({}, total), current);
                if (current.account && !total.account) {
                    total.account = current.account;
                }
                return total;
            }, {}));
        }), shareReplay(1));
        this.observable = $observable;
    }
    subscribeContactReady() {
        const onnotify = (handler) => {
            this.eventApi.registerSysEventObserver('updateUserInfo', { func: handler });
        };
        const $notify = fromEventPattern(onnotify).pipe(take(1), mapTo(true), timeout({
            first: 5000,
        }), catchError($error => {
            console.warn('[im.myaccount]notify', $error);
            return from(Promise.resolve(true));
        }));
        return of(this.contactApi.getContactSyncTimes()).pipe(map(time => {
            if (time > 0) {
                return true;
            }
            throw new Error('contactUnSync');
        }), catchError(() => $notify));
    }
    getMyField(field = 'account') {
        return this.observable.pipe(distinct(info => info[field]), map(user => user[field]));
    }
}
